<template>
    <div>
        <el-row class="search-add" :gutter="15">
            <el-col :span="5">
                <el-input placeholder="虚拟设备号" v-model="virtual_device_id"></el-input>
            </el-col>
            <el-col :span="5">
                <el-input placeholder="真实设备号" v-model="hardware_device_id"></el-input>
            </el-col>
            <el-col :span="5">
                <el-input placeholder="机构名称" v-model="ins_name"></el-input>
            </el-col>
            <el-col :span="7">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="./add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <af-table-column prop="virtual_device_id" label="虚拟设备号">
            </af-table-column>
            <af-table-column prop="hardware_device_id" label="真实设备号">
            </af-table-column>
            <af-table-column prop="start_time" label="起始时间">
            </af-table-column>
            <af-table-column prop="end_time" label="终止时间">
            </af-table-column>
            <af-table-column prop="name" label="虚拟设备名称">
            </af-table-column>
            <af-table-column prop="term_version" label="设备型号">
            </af-table-column>
            <af-table-column prop="firm_version" label="固件版本">
            </af-table-column>
            <af-table-column prop="rom_model" label="固件型号">
            </af-table-column>
            <af-table-column prop="collect_time" label="最新上报时间">
            </af-table-column>
            <af-table-column prop="ins_name" label="机构">
            </af-table-column>
            <af-table-column prop="stock_status" label="库存状态">
                <template slot-scope="scope">
                    {{scope.row.stock_status | status}}
                </template>
            </af-table-column>
            <af-table-column label="查看历史数据">
                <template slot-scope="scope">
                    <router-link :to="'/equipment/equi/lishi/'+scope.row.hardware_device_id">
                        <el-button type="text" size="small">查看历史数据</el-button>
                    </router-link>
                </template>
            </af-table-column>
            <af-table-column fixed="right" label="操作" width="70">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.$index)" type="text" size="small">编辑</el-button>
                </template>
            </af-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                trem: '',//搜索框
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                virtual_device_id:'',
                hardware_device_id:'',
                ins_name:''
            }
        },
        filters:{
            status(value) {
                switch(value) {
                    case 0: return '待入库';break;
                    case 1: return '入库';break;
                    case 2: return '出库';break;
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                }
                if(this.virtual_device_id.trim() !='') {
                    params.virtual_device_id = this.virtual_device_id;
                }
                if(this.hardware_device_id.trim() !='') {
                    params.hardware_device_id = this.hardware_device_id;
                }
                if(this.ins_name.trim() !='') {
                    params.ins_name = this.ins_name;
                }
                this.$http.get('/manage/virtual_device/list', {params:params}).then(({data}) => {
                    this.data = data['data']['records'];
                    this.pagin.total = data['data']['total'];
                });
            },
            Edit(index) {
                this.$store.commit('setEditInfo',this.data[index]);
                this.$router.push('./edit/'+this.data[index].virtual_device_id);
            },
        },
        components: { Pagination }
    }
</script>